import * as React from "react";
import {Route, Switch} from "react-router-dom";
import LoanDetailsForConsent from "consent/loandetails";
import PAForm from "consent/paform";
import TimerDelay from "consent/timerdelay";
import Esign from "consent/esign";
import {history} from "load/store";
import ConsentCompleted from "consent/consentcompleted";
import RepaymentIndex from "consent/repayment";
import ConsentDenied from "consent/consentdenied";
import Redirection from "consent/redirection";
import {AndroidApis} from "app";
import ConsentError from "consent/consentError";
import LoanReject from "consent/loanReject";

let indexPath = null;

export enum RoutePaths {
  LOAN_DETAIL = "/loan-details",
  PA_FORM = "/pa-form",
  TIMER_DELAY = "/timer-delay",
  SHUBHSIGN = "/shubh-form",
  REPAYMENT = "/repay",
  CONSENT_COMPLETED = "/complete",
  CONSENT_DENIED = "/denied",
  REDIRECTION = "/redirection",
  CONSENT_ERROR = "/error",
  LOAN_REJECT = "/loan-reject",
}

export function getConsentRoutes(path: string) {
  return (
    <Switch>
      <Route exact path={`${path}`} component={LoanDetailsForConsent}/>
      <Route exact path={`${path}${RoutePaths.LOAN_DETAIL}`} component={LoanDetailsForConsent}/>
      <Route exact path={`${path}${RoutePaths.PA_FORM}`} component={PAForm}/>
      <Route exact path={`${path}${RoutePaths.TIMER_DELAY}`} component={TimerDelay}/>
      <Route exact path={`${path}${RoutePaths.SHUBHSIGN}`} component={Esign}/>
      <Route path={`${path}${RoutePaths.REPAYMENT}`} component={RepaymentIndex}/>
      <Route exact path={`${path}${RoutePaths.CONSENT_COMPLETED}`} component={ConsentCompleted}/>
      <Route exact path={`${path}${RoutePaths.CONSENT_DENIED}`} component={ConsentDenied}/>
      <Route exact path={`${path}${RoutePaths.REDIRECTION}`} component={Redirection}/>
      <Route exact path={`${path}${RoutePaths.CONSENT_ERROR}`} component={ConsentError}/>
      <Route exact path={`${path}${RoutePaths.LOAN_REJECT}`} component={LoanReject}/>
    </Switch>
  );
}

export function setConsentIndexPath(path: string) {
  indexPath = path;
}
export function handleConsentNavigation(navigateToPath, allowBackNavigation = true ) {
  const pathname = `${indexPath}${navigateToPath}`;
  if ( indexPath && allowBackNavigation ) {
      history.push({pathname: pathname.replace(/([^:]\/)\/+/g, "$1")});
  } else if (indexPath && !allowBackNavigation) {
      history.replace({pathname: pathname.replace(/([^:]\/)\/+/g, "$1")});
  }
}
